import { render } from "./IndexModal.vue?vue&type=template&id=eebb614c"
import script from "./IndexModal.vue?vue&type=script&lang=js"
export * from "./IndexModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__